/**
 * Feature Flags Configuration
 * 
 * Default feature flags - these are overridden by CMS settings.
 * The actual feature state is managed in the CMS under Site Settings.
 */

// Default values (fallback if CMS settings aren't available)
export const DEFAULT_FEATURES = {
  // Contact form section
  CONTACT_FORM: false as boolean,
  
  // Pricing guide section
  PRICING_GUIDE: false as boolean,
  
  // Add more features here as needed
  // SERVICES: true,
  // VIDEO_SECTION: true,
}

// This will be populated by the SiteSettingsProvider
export let FEATURES = { ...DEFAULT_FEATURES }

// Function to update features from CMS
export const updateFeatures = (features: Partial<typeof DEFAULT_FEATURES>) => {
  FEATURES = {
    ...DEFAULT_FEATURES,
    ...features
  }
}

// Helper to check if a feature is enabled
export const isFeatureEnabled = (feature: keyof typeof DEFAULT_FEATURES): boolean => {
  return FEATURES[feature]
}

